import script from "./MaterialMasterView.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialMasterView.vue?vue&type=script&setup=true&lang=js"

import "./MaterialMasterView.vue?vue&type=style&index=0&id=faa8794c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faa8794c"]])

export default __exports__